import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import ModalController from 'webmodals/modal.controller'
import Media from 'webutils/media/media'
import config from 'emun.on-demand/lib/_config'
import modals from 'webmodals/modals'
const excludeTagKinds = ['AreaId', 'Size', 'UserAuthId'];

class MediaPickerController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;
        console.warn('MediaPickerController', options);
        let context = (options.context || `Designer`);
        let url = $ctrl.baseUrl = 'QueryMediaTagKinds.json?Context=' + context;
        let request = {
            criteria: options.criteria || {},
            tagCriteria: options.tagCriteria || options.tags || {},
        };
        $ctrl.realm = options.realm || 'Media';
        $ctrl.title = options.title || `Select Media...`;
        $ctrl.subTitle = options.subTitle;
        $ctrl.panelType = 'default';

        $ctrl.pattern = options.pattern;
        $ctrl.accept = options.accept;
        let aqOptions = {
            pageSize: 24,
            tagTotalsUrl: 'QueryMediaTagTotals.json?Context=' + context,
            url: `QueryMedia.json?Context=${context}&Fields=Id,Label,Description,Tags,Url,CreatedOn,Active,Euid,Realm,ContentType,Height,Width`,
            orderBy: '-CreatedOn,Id',
            autoLoad: true,
            append: false,
            criteria: request.criteria,
            tagCriteria: request.tagCriteria,
            hideLeftNav: $ctrl.$pageConfig.is('lt-md'),
            navs: [],
            filters: config.mediaFilters,
            //criteria: $stateParams,
            scrub(response) {
                response.data.results = response.data.results.map(m => new Media(m));
                console.debug('media', response.data.results);
            },
            sortOptions: {
                'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
                'Label': 'Label: A to Z',
                '-Label': 'Label: Z to A',
                'ContentLength': 'Size: Smallest to Largest',
                '-ContentLength': 'Size: Largest to Smallest',
                'Description': 'Description: A to Z',
                '-Description': 'Description: Z to A',
                '-Rating': 'Rating: High to Low',
                'Rating': 'Rating: Low to High',
                'CreatedOn,Id': 'Created: Newest',
                '-CreatedOn,Id': 'Created: Newest',
                'Active': 'Active: A to Z',
                '-Active': 'Active: Z to A',
            }
        }

        $ctrl.query = new AutoQuery(aqOptions);
        $ctrl.bus = $ctrl.query.bus;
    }

    upload($files) {
        const $ctrl = this;
        if ($files && $files.length) {
            let req = {
                request: {
                    realm: $ctrl.realm,
                    tags: $ctrl.query.getTagCriteria()
                },
                files: $files,
                urls: []
            };

            $ctrl.bus.upload('CreateMedia.json', req).then(
                res => {
                    let media = res.data.media.map(m => new Media(m));
                    $ctrl.close(media);
                }, res => modals.alert(JSON.stringify(res), 'Could not save media!'));
        }
    }

    select(media) {
        const $ctrl = this;
        $ctrl.close([media]);
    }

    $onDestroy() {
        this.query.dispose();
    }
}

export default MediaPickerController;